import { watch } from "vue";
import { cancelEInvoice, deleteEInvoice, getDetailEInvoice, getEInvoiceConfiguration } from "@/api/action-defines/e-invoice-management";
import { getPaymentMethods } from '@/api/action-defines/e-invoice-management';
import { viewPdfEInvoice} from "@/api/action-defines/e-invoice-management"

import ModuleEInvoiceDetail from "@/views/components/module-einvoice-detail";
import AddEInvoice from '@/views/modules/e-invoice/add-e-invoice';
import flatPickr from "vue-flatpickr-component";

import dayjs from "dayjs";
import { getSitePartner } from "@/api/action-defines/site-management.js";
import { PartnerCode } from "@/@core/data/enum/partnerCode.js";
import { INVOICE_STATUS, INVOICE_STATUS_CODE, TAX_AUTHORITY_STATUS } from "@/@core/data/enum/invoiceStatus.js";
import { EInvoiceActionCodes } from "@/@core/data/enum/menuCode.js";
import { mapGetters } from "vuex";
import { INVOICE_ACTION } from "@/@core/data/enum/eInvoiceActionType.js";
import router from '@/router';

export default {
  name: "EInvoiceDetailDisable",
  components: {
    ModuleEInvoiceDetail,
    AddEInvoice,
    flatPickr,
  },
  data() {
    return {
      isOpen: false,
      isInvoiceDetailInfoShow: false,
      statusList: [...INVOICE_STATUS],
      taxAuthorityStatus: [...TAX_AUTHORITY_STATUS],
      formData: {
        InvoiceDate: "",
        InvoiceNum: "",
        Serial: null,
        FormInvoice: null,
        Buyer: null,
        Phone: null,
        Email: null,
        Company: null,
        CompanyAddress: null,
        CustomerAddress: null,
        VATCode: null,
        BankName: null,
        BankAccount: null,
        PaymentMethod: "",
        ThirdPartyInvoiceNumber: "",
        CCCD: null,
        Passport: null
      },
      listSerial: [],
      listForm: [],
      paymentMethodList: [
      ],
      EinvoiceDetailData: {},
      partnerInfo: {},
      eInvoiceConfig: {},
    };
  },
  async created() {
    await this.getPaymentMethods();
    await this.getPartnerInfo();
    await this.getEConfig();
  },
  methods: {
    async closeEInvoiceDetail() {
      this.isOpen = false;
      document.querySelector("body").style.overflow = "unset";
    },

    async getEConfig() {
      getEInvoiceConfiguration().then(res => {
        if(res.StatusCode === '200') {
          this.eInvoiceConfig = res.Data.EInvoiceConfig;
        }
      })
    },

    openDeletePopup() {
      this.$refs.confirmDelete.isOpen = true;
    },

    openCancelPopup() {
      this.$refs.confirmCancel.isOpen = true;
    },

    async confirmCancel(reason) {
      const BodyData = {
        Id: this.EinvoiceDetailData.Id,
        Reason: reason,
      };
      await cancelEInvoice({ BodyData: BodyData })
        .then((res) => {
          if (res.StatusCode === '200') {
            this.$refs.confirmCancel.isOpen = false;
            this.isOpen = false;
            showToast('success', this.$t('common_success'));
          }
        })
    },

    async confirmDelete(reason) {
      const BodyData = {
        Id: this.EinvoiceDetailData.Id,
        Reason: reason,
      };
      await deleteEInvoice({ BodyData: BodyData })
        .then((res) => {
          if (res.StatusCode === '200') {
            this.$refs.confirmDelete.isOpen = false;
            this.isOpen = false;
            showToast('success', this.$t('common_success'));
          }
        })
    },
    
    async getPaymentMethods() {
      const BodyData = {
        Partner: {
          All: false,
          In: [],
        }
      }
      getPaymentMethods({ BodyData })
        .then(res => {
          if (res.StatusCode === '200') {
            this.paymentMethodList = res.Data.map(method => {
              return {
                text: method.PaymentDescription,
                value: method.PaymentCode,
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    
    async getPartnerInfo() {
      const res = await getSitePartner();
      this.partnerInfo = res.Data;
    },

    getSignStatusUI(status) {
      if(status) {
        return {
          text: this.$t('common_signed'),
          color: 'text-success'
        }
      } else {
        return {
          text: this.$t('common_not_signed'),
          color: 'text-warning'
        }
      }
    },
    
    getInvoiceStatusUI(statusId) {
      if(!this.statusList) return
     
      const status =  this.statusList.find(s => s.id === statusId)

      if(!status) return {
        text: '',
        styles: '',
      }
      
      return {
        ...status,
        text: this.$t(status.text)
      }
    },
    getTaxAuthorityStatusUI(statusId) {
      if(!this.taxAuthorityStatus) return
     
      const status =  this.taxAuthorityStatus.find(s => s.id === statusId)

      if(!status) return {
        text: '',
        styles: '',
      }
      
      return {
        ...status,
        text: this.$t(status.text)
      }
    },

    openReplaceInvoice() {
      this.isOpen = false;
      this.$refs.addEInvoice.isOpen = true;
    },

    openAdjustInvoice(adjustActionCode) {
      if(adjustActionCode === INVOICE_ACTION.ADJUST_INVOICE) {
        this.$refs.adjustEInvoice.isOpen = true;
        this.isOpen = false;
      }
      if(adjustActionCode === INVOICE_ACTION.ADJUST_INVOICE_INFORMATION) {
        this.$refs.adjustEInvoiceInformation.isOpen = true;
        this.isOpen = false;
      }
      if(adjustActionCode === INVOICE_ACTION.ADJUST_INVOICE_VALUE) {
        this.$refs.adjustEInvoiceValue.isOpen = true;
        this.isOpen = false;
      }
      if(adjustActionCode === INVOICE_ACTION.ADJUST_INCREASE_INVOICE) {
        this.$refs.adjustIncreaseEInvoice.isOpen = true;
        this.isOpen = false;
      }
      if(adjustActionCode === INVOICE_ACTION.ADJUST_DECREASE_INVOICE) {
        this.$refs.adjustDecreaseEInvoice.isOpen = true;
        this.isOpen = false;
      }
    },
    async redirectInvoiceReference(id){
      const BodyDataGetDetail = {
        EInvoiceId: id,
      };
      this.einvoice = {};
      await getDetailEInvoice({ BodyData: BodyDataGetDetail })
          .then((res) => {
            if (res.StatusCode === "200") {
              this.einvoice = res.Data;
            } else {
              console.log(res.Messages);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        if (this.einvoice){
          function openEInvoiceInNewTab(ezInvoiceId) {
            const resolved = router.resolve({
              path: '/e-invoice',
              query: { ezInvoiceId }
            })
            // mở tab mới
            window.open(resolved.href, '_blank', 'noopener,noreferrer')
          }
          const { MINVOICE, CYBER_BILL , VIETTEL, VNPT, SUN, MISA} = PartnerCode;
          const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT } = INVOICE_STATUS_CODE;

          if ([MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)
              && ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
                  || ([DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign))
              && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
          ){
            openEInvoiceInNewTab(this.einvoice.EInvoice.EzInvoiceId);
          }else if ([VIETTEL, VNPT, SUN, MISA].includes(this.partnerInfo.PartnerCode)
              && [DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
              && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
          ){
            openEInvoiceInNewTab(this.einvoice.EInvoice.EzInvoiceId);
          }else {
            openEInvoiceInNewTab(this.einvoice.EInvoice.EzInvoiceId);
          }
        }
    },
    async handleReferenceClick(id){
      const BodyDataGetDetail = {
        EInvoiceId: id,
      };
      this.einvoice = {};
      await getDetailEInvoice({ BodyData: BodyDataGetDetail })
        .then((res) => {
          if (res.StatusCode === "200") {
            this.einvoice = res.Data;
          } else {
            console.log(res.Messages);
          }
        })
        .catch((error) => {
          console.log(error);
      });

      if (this.einvoice){
        const BodyDataViewPdf = {
          InvoiceCreateStatus: this.einvoice.EInvoice.StatusEinvoice === 6 ? "Draft" : "Official",
          ezInvoiceId: this.einvoice.EInvoice.EzInvoiceId,
          ThirdPartyInvoiceNumber: this.einvoice.EInvoice.ThirdPartyInvoiceNumber,
          ThirdPartyInvoiceCode: "",
          TransactionId: this.einvoice.EInvoice.TransactionId,
          searchCode: this.einvoice.EInvoice.SearchCode,
          invtmp: 0,
          FormNo: this.einvoice.EInvoice.FormNo,
          Serial: this.einvoice.EInvoice.Serial ? this.einvoice.EInvoice.Serial : "",
          InvoiceType: 0,
          TypeEinvoice: 0
        };
        await viewPdfEInvoice({ BodyData: BodyDataViewPdf }).then(res => {
          if (res.StatusCode === '200') {
            this.$toast.success(this.$t('success'));
            if (res.Data.Type === 1){
              const base64PDF = res.Data.InvoicePDF;
              const byteCharacters = atob(base64PDF);
              const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
              const byteArray = new Uint8Array(byteNumbers);

              const blob = new Blob([byteArray], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl);
            }

            if (res.Data.Type === 2){
              const pdfUrl = res.Data.InvoicePDF; // link trả về từ API
              window.open(pdfUrl, '_blank');
            }
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
          }
        })

      }
    },
  },
  watch: {
    async isOpen(newVal, oldVal) {
      if(!newVal) {
        document.querySelector('html').style.overflow = 'scroll';
        return;
      };
      document.querySelector('html').style.overflow = 'hidden';
      await this.getEConfig();
      this.$refs.detailBody.focus();

      const BodyData = {
        EInvoiceId: this.EinvoiceDetailData.Id,
      };
      await getDetailEInvoice({ BodyData: BodyData })
      .then((res) => {
          this.ListReference = [];
          if (res.StatusCode === "200") {
            const items = res.Data.EInvoiceDetails.map(item => {
              return {
                ...item, 
                ItemId: item.Id,
                TotalAmount: item.AfterTaxAmount,
                Tax: item.TaxRate,
                ChargesAmount: item.ServicesCharge,
                Charges: item.ServiceRate,
                DisplayUnitPrice : item.Price || 0,

                TaxReduction43Amount: item.TaxReduction43Amount || 0,
                isBHInvoice: this.eInvoiceConfig.InvoiceType === 'BH_INVOICE'
              };
            })
            this.$refs.moduleEInvoiceDetail.eInvoiceConfig = this.eInvoiceConfig;
            this.$refs.moduleEInvoiceDetail.typeDisplay = "view_detail";
            
            // Override all editing methods to prevent any interaction in view mode
            this.$refs.moduleEInvoiceDetail.openItemEditPopup = () => {};
            this.$refs.moduleEInvoiceDetail.setEditing = () => {};
            this.$refs.moduleEInvoiceDetail.setEditingGroupName = () => {};
            this.$refs.moduleEInvoiceDetail.setEditingCollapse = () => {};
            this.$refs.moduleEInvoiceDetail.saveEdit = () => {};
            this.$refs.moduleEInvoiceDetail.saveEditingGroupName = () => {};
            this.$refs.moduleEInvoiceDetail.addExternalService = () => {};
            this.$refs.moduleEInvoiceDetail.removeAt = () => {};
            this.$refs.moduleEInvoiceDetail.selectItem = () => {};
            this.$refs.moduleEInvoiceDetail.selectAllInGroup = () => {};
            this.$refs.moduleEInvoiceDetail.selectAll = () => {};
            this.$refs.moduleEInvoiceDetail.mergeSelectedItem = () => {};
            this.$refs.moduleEInvoiceDetail.separateSelectedItems = () => {};
            this.$refs.moduleEInvoiceDetail.deleteSelectedItems = () => {};
            
            this.$refs.moduleEInvoiceDetail.fillItemsDetail(items);
            this.listReference = res.Data.ListReference;
            // đổ dữ liệu
            this.formData.InvoiceDate = dayjs(res.Data.EInvoice.EinvoiceDate).toDate();
            this.formData.InvoiceNum = res.Data.EInvoice.EinvoiceNo;
            this.formData.Serial = res.Data.EInvoice.Serial;
            this.formData.FormInvoice = res.Data.EInvoice.FormNo;
            this.formData.Buyer = res.Data.EInvoice.CustomerName;
            this.formData.Phone = res.Data.EInvoice.CustomerPhone;
            this.formData.Email = res.Data.EInvoice.CustomerEmail;
            this.formData.Company = res.Data.EInvoice.CompanyName;
            this.formData.CustomerAddress = res.Data.EInvoice.CustomerAddress;
            this.formData.CompanyAddress = res.Data.EInvoice.CompanyAddress;
            this.formData.VATCode = res.Data.EInvoice.CustomerTax;
            this.formData.BankName = res.Data.EInvoice.BankName;
            this.formData.BankAccount = res.Data.EInvoice.BankAccount;
            this.formData.PaymentMethod = res.Data.EInvoice.PaymentMethodCode;
            this.formData.ThirdPartyInvoiceNumber = res.Data.EInvoice.ThirdPartyInvoiceNumber;
            this.formData.Cccd = res.Data.EInvoice.Cccd;
            this.formData.Passport = res.Data.EInvoice.Passport;
            this.formData.BudgetCode = res.Data.EInvoice.BudgetCode;
          } else {
            console.log(res.Messages);
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
  },
  computed: {
    ...mapGetters({
      $lsAllowOperation: 'app/allowOperation',
    }),
    isCanDraftInvoice() {
      const { VIETTEL, VNPT, VNPT_V5, SUN } = PartnerCode;
      if ([VIETTEL, VNPT, VNPT_V5, SUN].includes(this.partnerInfo.PartnerCode)) {
        if (acceptableInvoiceStatus.includes(this.EinvoiceDetailData.StatusEInvoice) &&
          this.$lsAllowOperation(EInvoiceActionCodes.DRAFT)
        ) {
          return true;
        }
      }
      return false;
    },
    isCanReleaseInvoice() {
      const { DRAFT } = INVOICE_STATUS_CODE;
      return this.$lsAllowOperation(EInvoiceActionCodes.RELEASE) &&
      this.EinvoiceDetailData.StatusEInvoice === DRAFT;
    },
    isCanReplaceEInvoice() {
      const acceptableInvoiceStatus = [INVOICE_STATUS_CODE.ORIGINAL, INVOICE_STATUS_CODE.REPLACEMENT];
      const { CMC, MINVOICE } = PartnerCode;
      if ([CMC, MINVOICE].includes(this.partnerInfo.PartnerCode)) {
        if (acceptableInvoiceStatus.includes(this.EinvoiceDetailData.StatusEInvoice) &&
          this.$lsAllowOperation(EInvoiceActionCodes.REPLACE) &&
          !!this.EinvoiceDetailData.StatusSign
        ) {
          return true;
        }
      }

      const { VIETTEL, VNPT, VNPT_V5, CYBER_BILL, MISA } = PartnerCode;
      if ([VIETTEL, VNPT, VNPT_V5, CYBER_BILL, MISA].includes(this.partnerInfo.PartnerCode)) {
        if (acceptableInvoiceStatus.includes(this.EinvoiceDetailData.StatusEInvoice) &&
          this.$lsAllowOperation(EInvoiceActionCodes.REPLACE)
        ) {
          return true;
        }
      }

      return false;
    },
    isSigned() {
      return this.EinvoiceDetailData.StatusSign;
    },

    isCanCancelEInvoice() {
      const { CMC, MINVOICE, VIETTEL, VNPT, VNPT_V5, CYBER_BILL, MISA, SUN } = PartnerCode;
      const { ORIGINAL, ADJUSTED, ADJUSTMENT, REPLACED, REPLACEMENT } = INVOICE_STATUS_CODE;

      const acceptPartner = [CMC, MINVOICE, VIETTEL, VNPT, VNPT_V5, CYBER_BILL, MISA, SUN];
      const acceptEInvoiceStatus = [ORIGINAL, ADJUSTED, ADJUSTMENT, REPLACED, REPLACEMENT];

      return acceptPartner.includes(this.partnerInfo.PartnerCode) &&
        acceptEInvoiceStatus.includes(this.EinvoiceDetailData.StatusEInvoice) &&
        this.$lsAllowOperation(EInvoiceActionCodes.CANCEL);
    },

    isCanDeleteEInvoice(){
      const { MINVOICE, CYBER_BILL, VNPT, VNPT_V5, EASY} = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT} = INVOICE_STATUS_CODE;

      if (this.$lsAllowOperation(EInvoiceActionCodes.DELETE)){
        if ([MINVOICE].includes(this.partnerInfo.PartnerCode)) {
          if ([ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign ){
            return true;
          }
        }

        if ([CYBER_BILL].includes(this.partnerInfo.PartnerCode)) {
          if ([ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign ){
            return true;
          }

          if ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)){
            return true;
          }
        }

        if ([VNPT, VNPT_V5, EASY].includes(this.partnerInfo.PartnerCode)) {
          if ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)){
            return true;
          }
        }
      }

      return false;
      

    },

    isShowStatusSign(){
      const { VIETTEL, SUN, MISA, VNPT, VNPT_V5, FAST, EASY} = PartnerCode;

      if (![VIETTEL, SUN, MISA, VNPT, VNPT_V5, FAST, EASY].includes(this.partnerInfo.PartnerCode)) {
        return true;
      }

      return false;

    },

    //TODO - Add user permission
    isCanAdjustEInvoiceButton() {
      let qualifiedCondition = false;
      const { MINVOICE, CYBER_BILL, MISA, VIETTEL, FAST, EASY, VNPT, VNPT_V5  } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;
      if ([MINVOICE, CYBER_BILL, MISA, VIETTEL, FAST, EASY, VNPT, VNPT_V5 ].includes(this.partnerInfo.PartnerCode)
        && [ORIGINAL, ADJUSTED].includes(this.EinvoiceDetailData.StatusEInvoice)
      ) {
        qualifiedCondition = true;
      }

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        this.EinvoiceDetailData.StatusSign &&
        qualifiedCondition;
    },
    isCanAdjustEInvoice() {
      let qualifiedCondition = false;
      const { MINVOICE, CYBER_BILL, MISA } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      if ([MINVOICE, CYBER_BILL, MISA].includes(this.partnerInfo.PartnerCode) &&
        [ORIGINAL, ADJUSTED].includes(this.EinvoiceDetailData.StatusEInvoice)
      ) {
        qualifiedCondition = true;
      }

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        this.EinvoiceDetailData.StatusSign &&
        qualifiedCondition;
    },
    isCanIncreaseAdjustmentEInvoice() {
      return this.isCanAdjustEInvoiceInformation || false;
    },
    isCanDecreaseAdjustmentEInvoice() {
      return this.isCanAdjustEInvoiceInformation || false;
    },
    isCanAdjustEInvoiceValue() {
      const { CYBER_BILL } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      const partnerList = [CYBER_BILL];
      const statusList = [ORIGINAL, ADJUSTED];

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        partnerList.includes(this.partnerInfo.PartnerCode) &&
        statusList.includes(this.EinvoiceDetailData.StatusEInvoice);
    },
    isCanAdjustEInvoiceInformation() {
      const {  VIETTEL, FAST, EASY, VNPT, VNPT_V5 } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      const partnerList = [VIETTEL, FAST, EASY, VNPT, VNPT_V5];
      const statusList = [ORIGINAL, ADJUSTED];

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        partnerList.includes(this.partnerInfo.PartnerCode) &&
        statusList.includes(this.EinvoiceDetailData.StatusEInvoice);
    },
    computedFormData() {
      return {
        InvoiceDate: this.props.InvoiceDate || "",
        InvoiceNum: this.props.InvoiceNum || "",
        Serial: this.props.Serial || null,
        FormInvoice: this.props.FormInvoice || null,
        Buyer: this.props.Buyer || null,
        Phone: this.props.Phone || null,
        Email: this.props.Email || null,
        Company: this.props.Company || null,
        Address: this.props.Address || null,
        VATCode: this.props.VATCode || null,
        BankName: this.props.BankName || null,
        BankAccount: this.props.BankAccount || null,
        PaymentMethod: this.props.PaymentMethod || "",
        Cccd: this.props.Cccd || null,
        Passport: this.props.Passport || null,
      };
    },
  },
};
